export default __webpack_public_path__ + "static/media/Notifications_Icon.74649bb5.svg";